<template>
  <div class="wrapper">

    <SearchForm></SearchForm>

    <div class="row" id="categories-list">
      <div class="col-sm-6" v-for="category in categories">
        <h2><i :class="category.icon_class"></i> <router-link :to="{ name: 'Page', params: { page_id: category.id }}">{{category.name}}</router-link></h2>
        <b-list-group>
          <b-list-group-item v-for="item in category.children" :key="item.id">
            <router-link :to="{ name: 'Page', params: { page_id: item.id }}">{{item.name}}</router-link> <i class="icon-arrow-right"></i>
          </b-list-group-item>
        </b-list-group>

      </div>
    </div>

  </div>

</template>


<script>
import SearchForm from './SearchForm'

export default {
  name: 'Index',
  components: {
    SearchForm
  },
  data () {
    return {
      categories: ''
    }
  },
  mounted: function() {
    this.getCategories();
  },
  methods: {
    getCategories() {
        axios.get(this.$conf.apiHost+'/api/faq/categories?site='+this.$conf.siteId).then((response) => {
          this.categories = response.data[0].children;
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Index.vue